import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-switch-formly',
	templateUrl: './lu-switch-formly.component.html'
})
export class LuSwitchFormlyComponent extends FieldType implements OnInit {
	switchDisabled: boolean;

	ngOnInit(): void {
		this.switchDisabled = !!this.field.templateOptions.disabled;
	}

	change($event): void {
		if (!!this.field.templateOptions && !!this.field.templateOptions.change) {
			this.field.templateOptions.change(this.field, $event);
		}
	}
}
